// src/components/job-engine/DashboardTiles.tsx
import React from "react";
import { Stack, Text } from "@fluentui/react";
import type { DashboardTiles as Tiles } from "@/api/jobEngine";

interface Props { data: Tiles | null; }

const Tile: React.FC<{ label: string; value: React.ReactNode; accent?: string }> = ({ label, value, accent }) => (
  <Stack
    tokens={{ childrenGap: 6 }}
    styles={{
      root: {
        flex: "1 1 180px",
        minWidth: 180,
        padding: 16,
        borderRadius: 6,
        backgroundColor: "#faf9f8",
        border: "1px solid #edebe9",
        borderTop: accent ? `3px solid ${accent}` : undefined,
      },
    }}
  >
    <Text variant="small" styles={{ root: { color: "#605e5c", textTransform: "uppercase", letterSpacing: 0.5 } }}>{label}</Text>
    <Text variant="xxLarge" styles={{ root: { fontWeight: 600 } }}>{value}</Text>
  </Stack>
);

const DashboardTiles: React.FC<Props> = ({ data }) => (
  <Stack horizontal wrap tokens={{ childrenGap: 16 }}>
    <Tile label="In flight"       value={data?.inFlightCount ?? "—"}           accent="#0078d4" />
    <Tile label="Succeeded / min" value={data?.succeededPerMinute ?? "—"}     accent="#107c10" />
    <Tile label="Failed / min"    value={data?.failedPerMinute ?? "—"}        accent="#d13438" />
    <Tile label="Dead-letter depth" value={data?.deadLetterDepthTotal ?? "—"} accent="#a80000" />
  </Stack>
);

export default DashboardTiles;
